import { atom, selector } from "recoil";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const activityHistoryListState = atom({
    key: 'activityHistoryListState',
    default: [],
})


export const modalConfigDefault = { size: "md", wizard: false }

export const activityHistoryFilterState = selector({
    key: 'activityHistoryFilterState',
    get: () => ([])
})


export const formModes = {
    view: [ { name: 'Default View' } ],
}

export const activityHistoryDataStructureState = selector({
    key: 'activityHistoryDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: 'Reference',
                field: 'transaction_reference',
                type: 'text',
                order: { table: 1, form: 1 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Mode',
                type: 'text',
                order: { table: 2, form: 2 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Type',
                field: 'activity_type',
                type: 'text',
                order: { table: 3, form: 3 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Amount',
                type: 'number',
                order: { table: 4, form: 4 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Balance',
                type: 'number',
                order: { table: 5, form: 5 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },
            { 
                label: 'Description',
                type: 'number',
                order: { form: 6 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }], 
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
